<template>
  <settings-section
    :title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_COEX.TITLE')"
    :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_COEX.SUBHEADER')"
  >
    <div class="whatsapp-coex--content">
      <label class="input-container input">
        <select
          v-model="coexEnabled"
          class="whatsapp-coex--select"
          :disabled="isSaving"
        >
          <option :value="true">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_COEX.ENABLED') }}
          </option>
          <option :value="false">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_COEX.DISABLED') }}
          </option>
        </select>
      </label>
      <woot-button :is-loading="isSaving" @click="updateCoexEnabled">
        {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_UPDATE_BUTTON') }}
      </woot-button>
    </div>
  </settings-section>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import SettingsSection from 'dashboard/components/SettingsSection';

export default {
  components: {
    SettingsSection,
  },
  mixins: [alertMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      coexEnabled: false,
      isSaving: false,
    };
  },
  watch: {
    'inbox.id'() {
      this.setDefaults();
    },
    'inbox.coex_enabled'() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.coexEnabled = this.inbox.coex_enabled || false;
    },
    async updateCoexEnabled() {
      this.isSaving = true;
      try {
        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.inbox.id,
          formData: false,
          coex_enabled: this.coexEnabled,
        });
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.setDefaults();
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-coex--content {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-top: var(--space-small);

  .input {
    flex: 1;
    margin-right: var(--space-small);
  }
}

.whatsapp-coex--select {
  margin-bottom: 0;
}
</style>
